/** Minimal horizontal pan to uncover a selection, without hiding its opposite edge. */
export function revealSelection(box: { left: number; right: number }, visible: { left: number; right: number }): number {
  if (box.left < visible.left && box.right < visible.right) return Math.min(visible.left - box.left, visible.right - box.right);
  if (box.right > visible.right && box.left > visible.left) return -Math.min(box.right - visible.right, box.left - visible.left);
  return 0;
}
